module.exports = __webpack_public_path__ + "static/media/settings-512x512.884b2401.png";